'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _transparentize = require('polished/lib/color/transparentize');

var _transparentize2 = _interopRequireDefault(_transparentize);

var _config = require('../config.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransparentOverlay = function TransparentOverlay(options) {
  var defaults = {
    color: _config.colors.darkBlue,
    gradent: false
  };
  var settings = _extends({}, defaults, options);

  var background = settings.gradient ? 'linear-gradient(' + (0, _transparentize2.default)(0.2, settings.color) + ', ' + settings.color + ' 75%)' : '' + (0, _transparentize2.default)(0.2, settings.color);

  return '\n    &::before {\n      background: ' + background + ';\n      content: \'\';\n      height: 100%;\n      left: 0;\n      position: absolute;\n      top: 0;\n      width: 100%;\n      z-index: 1;\n    }\n  ';
};

exports.default = TransparentOverlay;